export default __webpack_public_path__ + "static/media/quentinG.bc24b238.png";